import {VideoControl} from "../model/types";

export const DEFAULT_CONTROLS: VideoControl[] = [
    "play",
    "volume",
];
